import React, { useEffect } from 'react';
import { DataManager } from '../../../core/data-manager';


export default function IC_shipping_plan({ data, entity = null, setDataKeyValue }) {



    async function searchForwarder() {
        var constraints = [
            { fieldName: "isDefault", type: "value", value: 1 }
        ]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.searchItems('forwarder', 1, 100, sorting, '', [], constraints);
        if (response.success === 1 && response.body.length > 0) {
            console.log(response);
            if(data.idForwarder !== response.body[0]){
                setDataKeyValue('idForwarder', response.body[0])
            }
        }
    }

    useEffect(() => {
        console.warn('DATA', data);
        if (data.idForwarder === "") {
            searchForwarder();
        }
    }, [data]);




    return (
        <>
        </>
    )
};